export const CHATBOT_WELCOME_VISIBLE_KEY = 'chatbot_welcome_visible'
